import { MetalCreate } from "@/modules/metal/MetalCreate.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/metal/create")({
    component: MetalCreate,
});
